/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = require('lib/util/helpers').imageLoaded;

/**
 * User: konstantin
 * Date: 4/8/14
 */
(function ($) {
	'use strict';
	/*globals Tc, scent*/
	/*jshint smarttabs:false */

	Tc.Module.ImagesSlider = Tc.Module.extend({
		config: {
			fullWidthWrapperClass: '.fullwidthwrapper',
			normalWidthWrapperClass: '.normalwidthwrapper',
			imagefullwidthClass: '.imagefullwidth',
			slider: '.slider',
			slide: '.slidesjs-slide',
			image: '.slider img',
			prevLinkClass: '.sjs-prev',
			nextLinkClass: '.sjs-next',
			bildlegendeSpan: '.bildlegende > span',
			bildlegendeClass: '.bildlegende',
			facebookShare: 'a.facebook',
			twitterShare: 'a.twitter',
			mail: 'a.mail'
		},

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			setTimeout(function() {
				mod.checkWidth(0);
				mod.initSlider();
				mod.sliderButtons();
				mod.initCaptionText();
				mod.centerCaptionText();
				mod.captionHovering();
				mod.centerImages();
			}, 200);

			$(window).resize(function () {
				setTimeout(function() {
					mod.checkWidth(0);
					mod.initCaptionText();
					mod.centerCaptionText();
					mod.centerImages();
				}, 200);
			});


			Promise.all(mod.$ctx.find('img').get().map(imageLoaded)).then(function() {
				setTimeout(function () {
					mod.checkWidth(0);
					mod.initCaptionText();
					mod.centerCaptionText();
					mod.centerImages();
				}, 200);
			});

			mod.shareImages();

			callback();
		},
		centerImages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config;

			var maxHeight = mod.getSlideMaxHeight();
			if(scent.global.isMobile()) {
				maxHeight = maxHeight + mod.getCaptionMaxHeight();
			}

			$(config.normalWidthWrapperClass, $ctx).css({height: maxHeight});
			$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());

			$(config.fullWidthWrapperClass, $ctx).css({height: maxHeight});
			$(config.imagefullwidthClass, $ctx).css({height: maxHeight});
			$('.slidesjs-container', $ctx).css({height: maxHeight});
			$('.slidesjs-control', $ctx).css({height: maxHeight});

			$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());

			$(config.slide, $ctx).css({height: maxHeight});

			$(config.image, $ctx).each(function () {
				var $this = $(this);

				if($this.width() > $this.parent().width()){
					$this.css({'float': 'left', 'width': '100%'});
				}

				var height = $this.height();
				if(scent.global.isMobile()) {
					height = height + mod.getCaptionMaxHeight();
				}
				var heightHalf = -1 * Math.round(height / 2);
				$this.css({'margin-top': heightHalf + 'px'});
			});
		},

		shareImages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config;

			$ctx.on('click', config.facebookShare, function () {
				var $this = $(this);
				mod.shareImage('http://www.facebook.com/share.php?u=' + $this.closest(config.slide).find('img').prop('src') + '&amp;title=' + $this.parent().data('share-text'));
				return false;
			});
			$ctx.on('click', config.twitterShare, function () {
				var $this = $(this);
				mod.shareImage('http://twitter.com/home?status=' + $this.parent().data('share-text') + '+' + $this.closest(config.slide).find('img').attr('src'));
				return false;
			});
			$ctx.on('click', config.mail, function () {
				var $this = $(this);
				document.location.href = 'mailto:?body=' + $this.closest(config.slide).find('img').attr('src') + '&subject=' + $this.data('share-text').replace(/&/g, '%26');
				return false;
			});
		},

		shareImage: function (url) {
			var w = 500;
			var h = 500;
			var left = (screen.width/2)-(w/2);
			var top = (screen.height/2)-(h/2);

			window.open(url,"_blank", "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
		},

		initSlider: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			// do not init slidesjs if only one image because of a known bug in the plugin
			// see https://groups.google.com/forum/#!msg/slidesjs/Q61KaOBzV4w/J_moJx0TxnMJ

			if (!mod.oneImage()) {

				if(scent.global.isMobile()) {
					$('.fullwidthwrapper', $ctx).height(($(config.fullWidthWrapperClass + ' .imagefullwidth img', $ctx).height() + mod.getCaptionMaxHeight()));

					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
						width: $(window).width(),
						height: ($(config.fullWidthWrapperClass + ' .imagefullwidth img', $ctx).height() + mod.getCaptionMaxHeight()),
						navigation: {
							active: false,
							effect: "slide"
						},
						pagination: {
							active: false
						}
					});
				} else {
					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
						width: $(window).width(),
						height: ($(config.fullWidthWrapperClass, $ctx).height() + mod.getCaptionMaxHeight()),
						navigation: {
							active: false,
							effect: "slide"
						},
						pagination: {
							active: false
						}
					});
				}

				$(config.normalWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
					width: 100,
					height: $(config.normalWidthWrapperClass, $ctx).height(),
					navigation: {
						active: false,
						effect: "slide"
					},
					pagination: {
						active: false
					}
				});

			}

			$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());

		},

		sliderButtons: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			if (!mod.oneImage()) {
				var sjs = $(config.slider, $ctx).data('plugin_slidesjs');
				$(config.nextLinkClass, $ctx).click(function (clickevent) {
					clickevent.preventDefault();
					sjs.next();
				});
				$(config.prevLinkClass, $ctx).click(function (clickevent) {
					clickevent.preventDefault();
					sjs.previous();
				});
			} else {
				$(config.nextLinkClass, $ctx).hide();
				$(config.prevLinkClass, $ctx).hide();
				$(config.bildlegendeSpan, $ctx).css('padding','10px');
				$(config.fullWidthWrapperClass + ' ' + config.bildlegendeSpan, $ctx).css('width','515px');
			}
		},
		initCaptionText: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider + ' p.bildlegende', $ctx).each(function () {
				$(this).height(mod.getCaptionMaxHeight());
			});

		},

		captionHovering: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider, $ctx).hover(
				function () {
					if (!scent.global.isMobile()) {
						$ctx.find('p.bildlegende').animate({
							height: mod.getCaptionMaxHeight()
						}, 500);
					}
				},
				function () {
					if (!scent.global.isMobile()) {
						$ctx.find('p.bildlegende').animate({
							height: 0
						}, 500);
					}
				}
			);
		},

		centerCaptionText: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider + ' p.bildlegende', $ctx).each(function () {
				$(this).height(mod.getCaptionMaxHeight());
			});
		},

		checkWidth: function (index) {
			var mod = this;
			var $ctx = this.$ctx;
			var config = this.config;

			if (scent.global.isMobile()) {
				$(config.bildlegendeClass, $ctx).removeAttr('style');

				var heightNormal = $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightNormal == null){
					heightNormal = $('.normalwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightNormal != null){
					$(config.normalWidthWrapperClass, $ctx).css({height: (heightNormal + $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] p.bildlegende', $ctx).height())});
					$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());
					$('.slidesjs-container', $ctx).css({height: $(config.normalWidthWrapperClass, $ctx).height()});
					$('.slidesjs-control', $ctx).css({height: $(config.normalWidthWrapperClass, $ctx).height()});
				}

				var heightFull = $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightFull == null){
					heightFull = $('.fullwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightFull != null){
					$(config.fullWidthWrapperClass, $ctx).css({height: heightFull + $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] p.bildlegende', $ctx).height()});

					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
					$(config.fullWidthWrapperClass + ' .slidesjs-container', $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
					$(config.fullWidthWrapperClass + ' .slidesjs-control', $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
				}

			} else {
				var heightNormal = $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightNormal == null){
					heightNormal = $('.normalwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightNormal != null){
					$(config.normalWidthWrapperClass, $ctx).css({height: heightNormal});
					$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());
				}

				var heightFull = $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightFull == null){
					heightFull = $('.fullwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightFull != null){
					$(config.fullWidthWrapperClass, $ctx).css({height: heightFull});
					$(config.imagefullwidthClass, $ctx).css({height: heightFull});
					$('.slidesjs-container', $ctx).css({height: heightFull});
					$('.slidesjs-control', $ctx).css({height: heightFull});
				}

				$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
			}
		},

		getCaptionMaxHeight: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			var maxheight = 55;

			$(config.slider + ' p.bildlegende span', $ctx).each(function () {
				var height = $(this).outerHeight();
				if (height > maxheight) {
					maxheight = height;
				}
			});
			if($ctx.data('share-enabled')){
				if(scent.global.isMobile()) {
					maxheight = maxheight + 43;
				} else {
					maxheight = maxheight + 20;
				}
			}

			return maxheight;
		},

		getSlideMaxHeight: function() {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			var maxheight = -1;

			$(config.image, $ctx).each(function () {
				var $this = $(this);

				var heightReal = $this.height();
				$this.css({'width': '100%'});
				var height100 = $this.height();

				var height = height100;
				if(height100 > heightReal){
					height = heightReal;
				}

				if (height > maxheight) {
					maxheight = height;
				}

				$this.css({'width': 'auto'});
			});

			return mod.oneImage() ? $(this).height() : maxheight;
		},

		oneImage: function () {
			return $(this.config.slider + " img", this.$ctx).length < 2;
		}

	});
}(Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.ImagesSlider.js
// module id = 40
// module chunks = 0